import React from 'react'
import ReactGA from 'react-ga'
import PropTypes from 'prop-types'
import { useQuery } from 'react-apollo'
import { RESTAURANT_INFO } from '../../apollo/restaurant.graphql'

const RestaurantContext = React.createContext({})

export const RestaurantProvider = ({ restaurantGuid, shortUrl, children }) => {
  const getRestaurantPath = (subpath = '') => {
    if (subpath && subpath[0] !== '/') {
      subpath = `/${subpath}`
    }

    return subpath || '/'
  }

  const context = {
    getRestaurantPath,
    restaurantGuid,
    shortUrl
  }

  ReactGA.set({
    dimension4: restaurantGuid
  })

  return (
    <RestaurantContext.Provider value={context}>
      {children}
    </RestaurantContext.Provider>
  )
}

RestaurantProvider.propTypes = {
  children: PropTypes.element.isRequired,
  restaurantGuid: PropTypes.string.isRequired,
  shortUrl: PropTypes.string.isRequired
}

const RestaurantConsumerInner = ({ context, children, ...opts }) => {
  const restaurantInfo = useQuery(RESTAURANT_INFO, { variables: { restaurantGuid: context.restaurantGuid }, ...opts })
  return children({ ...context, restaurantInfo }) || null
}

export const RestaurantConsumer = ({ ...opts }) => {
  return (
    <RestaurantContext.Consumer>
      {context => <RestaurantConsumerInner context={context} {...opts} />}
    </RestaurantContext.Consumer>
  )
}

RestaurantConsumer.propTypes = {
  children: PropTypes.func.isRequired
}

export const MockRestaurantProvider = ({
  mocks: {
    restaurantGuid,
    shortUrl
  },
  children
}) => {
  const context = {
    restaurantGuid,
    shortUrl,
    getRestaurantPath: () => shortUrl
  }

  return (
    <RestaurantContext.Provider value={context}>
      {children}
    </RestaurantContext.Provider>
  )
}

export const useRestaurant = (opts = {}) => {
  const context = React.useContext(RestaurantContext)
  const restaurantInfo = useQuery(RESTAURANT_INFO, { variables: { restaurantGuid: context.restaurantGuid }, ...opts })
  return { ...context, restaurantInfo }
}

MockRestaurantProvider.propTypes = {
  children: PropTypes.element.isRequired,
  mocks: PropTypes.shape({
    restaurantGuid: PropTypes.string,
    shortUrl: PropTypes.string
  }).isRequired
}
